import React from "react";
import styles from "./StrategyBadge.module.css";
import { LHF_CODES } from "../utils";

interface StrategyBadgeProps {
  code: string | null;
  group?: "LHF" | "CORE" | null;
}

export const StrategyBadge = React.memo(({ code, group }: StrategyBadgeProps) => {
  if (group === "LHF") return <span className={`${styles['strategy-badge']} ${styles['lhf']}`}>LHF</span>;
  if (group === "CORE") return <span className={`${styles['strategy-badge']} ${styles['core']}`}>CORE</span>;
  if (!code) return <span className={`${styles['strategy-badge']} ${styles['no-strategy']}`}>No Strategy</span>;
  if (LHF_CODES.has(code)) return <span className={`${styles['strategy-badge']} ${styles['lhf']}`}>{code}</span>;
  return <span className={`${styles['strategy-badge']} ${styles['core']}`}>{code}</span>;
});

StrategyBadge.displayName = "StrategyBadge";
